import { dayjs } from 'src/libs/dayjs';

export const formatTimeRemaining = (seconds: number | null): string => {
  if (!seconds || seconds <= 0) return '';

  const duration = dayjs.duration(seconds, 'seconds');
  const hours = Math.floor(duration.asHours());
  const minutes = duration.minutes();

  if (hours > 0) {
    return `~${hours}h ${minutes}m remaining`;
  }
  if (minutes > 0) {
    return `~${minutes}m remaining`;
  }
  return `~${Math.floor(duration.asSeconds())}s remaining`;
};
